
import { Box, useTheme, ButtonBase } from "@mui/material";
import { tokens } from "../../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useExportExcelMutation, useGetInvoiceMutationsQuery } from "../../../../../newapi/financial/invoiceSlice";
import { general_states } from "../../../../../utils/staticEnums";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { formatPrice } from "../../../../../utils/helpers";
import { getInvoiceMutationStateData } from "../../../../../utils/labelColorText";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { INVOICE_FILTER_KEYS, INVOICE_WITHOUT_COST_KEYS, INVOICEMUTATIONS_FILTER_KEYS } from "../../../../../components/global/DataGrid/Filter";
import { showToastMessage } from "../../../../../utils/toasts";
import MDynamicValues from "../../../../../components/global/Modals/MDynamicValues";
import { useGetRelationsSelectQuery } from "../../../../../newapi/global/relation/relationSlice";
import MLoader from "../../../../../components/global/Modals/MLoader";

const SpRelationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails"));
const SpInvoiceDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails"));
const SpInvoiceProductDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceProductDetails/SpInvoiceProductDetails"));
const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));
const SpInboundDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInboundDetails/SpInboundDetails"));
const SpReturnDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));
const SpShipmentDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpShipmentDetails/SpShipmentDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <ButtonGroup version={2}>
            <Shbutton
                onClick={props.handleExportClick}
                className={"group-btn"}
                color={"primaryGrey"}
                variant="contained"
                endIcon={<DownloadOutlinedIcon/>}
            >
                {t('export')}
            </Shbutton>
        </ButtonGroup>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [
        INVOICEMUTATIONS_FILTER_KEYS.STATE, INVOICEMUTATIONS_FILTER_KEYS.RELATION, INVOICEMUTATIONS_FILTER_KEYS.INVOICE_PRODUCT
    ],
};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [isRelationExtended, setIsRelationExtended] = useState(false);
    const [spRelationLoading, setSpRelationLoading] = useState();

    const [isInvoiceProductExtended, setIsInvoiceProductExtended] = useState(false);
    const [spInvoiceProductLoading, setSpInvoiceProductLoading] = useState();

    const [isOrderExtended, setIsOrderExtended] = useState(false);
    const [spOrderLoading, setSpOrderLoading] = useState();

    const [isReturnExtended, setIsReturnExtended] = useState(false);
    const [spReturnLoading, setSpReturnLoading] = useState();

    const [isInboundExtended, setIsInboundExtended] = useState(false);
    const [spInboundLoading, setSpInboundLoading] = useState();

    const [isShipmentExtended, setIsShipmentExtended] = useState(false);
    const [spShipmentLoading, setSpShipmentLoading] = useState();
    
    const ref = useRef();
    const [config, setConfig] = useState({
        //"userType": "user"
    });

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    const { data: relationData, relationIsLoading } = useGetRelationsSelectQuery();

    const [exportMutationsModalOpen, setExportMutationsModalOpen] = useState(false);
    const exportMutationsModal = {
        open: exportMutationsModalOpen,
        setOpen: setExportMutationsModalOpen
    }

    const [loaderModalOpen, setLoaderModalOpen] = useState(false);
    const loaderModal = {
        open: loaderModalOpen,
        setOpen: setLoaderModalOpen,
    };

    const [exportExcel, {isLoading: isMutationExporting}] = useExportExcelMutation();

    const exportToExcel = (values) => {
        if (isMutationExporting) return;
        if (!values.startdate || !/^\d{4}-\d{2}-\d{2}$/.test(values.startdate)) {
            showToastMessage("error", t("invalid_startdate"));
            return;
        }

        if (!values.enddate || !/^\d{4}-\d{2}-\d{2}$/.test(values.enddate)) {
            showToastMessage("error", t("invalid_enddate"));
            return;
        }

        // Validate date range does not exceed 28 days
        const startDateCheck = new Date(values.startdate);
        const endDateCheck = new Date(values.enddate);
        const daysDiff = Math.ceil((endDateCheck - startDateCheck) / (1000 * 60 * 60 * 24));

        if (daysDiff > 32) {
            showToastMessage("error", t("date_range_max_32_days"));
            return;
        }

        let queryString = `?startdate=${values.startdate}&enddate=${values.enddate}`;
        if (values.relation) {
            queryString += `&relation=${values.relation}`
        }

        loaderModal.setOpen(true);

        exportExcel({
            id: 0,
            queryString
        })
        .unwrap()
        .then(res => {
            console.log(res);
            showToastMessage("success", t("export_ready"));
        })
        .catch(e => {
            console.error(e);
            showToastMessage("error", t("export_failed"));
        })
        .finally(() => {
            loaderModal.setOpen(false);
        })
    }

    const [invoiceProductId, setInvoiceProductId] = useState();
    const invoiceProductIdRef = useRef(invoiceProductId);
    
    const getInvoiceProductDetails = (params) => {
        if (!params && params.row) return;
    
        const newInvoiceProductId = parseInt(params.row.invoiceProductId);
        // Only update state if the productId has actually changed
        if (invoiceProductIdRef.current !== newInvoiceProductId) {
            if(!spRelationLoading) {
                setSpInvoiceProductLoading(true);
            }
            setInvoiceProductId(newInvoiceProductId);
            invoiceProductIdRef.current = newInvoiceProductId; // Update the ref to the new value
        }
        setIsInvoiceProductExtended(true);
    };

    const [relationId, setRelationId] = useState();
    const relationIdRef = useRef(relationId);
    
    const getRelationDetails = (params) => {
        if (!params && params.row) return;
    
        const newRelationId = parseInt(params.row.relationId);
        // Only update state if the productId has actually changed
        if (relationIdRef.current !== newRelationId) {
            if(!spRelationLoading) {
                setSpRelationLoading(true);
            }
            setRelationId(newRelationId);
            relationIdRef.current = newRelationId; // Update the ref to the new value
        }
        setIsRelationExtended(true);
    };

    const [invoiceId, setInvoiceId] = useState();
    const invoiceIdRef = useRef(invoiceId);
    
    const getInvoice = (params) => {
        if (!params) return;
    
        const newInvoiceId = parseInt(params.row.invoiceId);
        // Only update state if the pickingJobListId has actually changed
        if (invoiceIdRef.current !== newInvoiceId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setInvoiceId(newInvoiceId);
            invoiceIdRef.current = newInvoiceId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params) return;
    
        const newOrderId = parseInt(params.row.orderId);
        // Only update state if the pickingJobListId has actually changed
        if (orderIdRef.current !== newOrderId) {
            if(!spOrderLoading) {
                setSpOrderLoading(true);
            }
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId; // Update the ref to the new value
        }
        setIsOrderExtended(true);
    };

    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(returnId);
    
    const getReturnDetails = (params) => {
        if (!params) return;
    
        const newReturnId = parseInt(params.row.returnId);
        // Only update state if the pickingJobListId has actually changed
        if (returnIdRef.current !== newReturnId) {
            if(!spReturnLoading) {
                setSpReturnLoading(true);
            }
            setReturnId(newReturnId);
            returnIdRef.current = newReturnId; // Update the ref to the new value
        }
        setIsReturnExtended(true);
    };

    const [inboundId, setInboundId] = useState();
    const inboundIdRef = useRef(inboundId);
    
    const getInboundDetails = (params) => {
        if (!params) return;
    
        const newInboundId = parseInt(params.row.inboundId);
        // Only update state if the pickingJobListId has actually changed
        if (inboundIdRef.current !== newInboundId) {
            if(!spInboundLoading) {
                setSpInboundLoading(true);
            }
            setInboundId(newInboundId);
            inboundIdRef.current = newInboundId; // Update the ref to the new value
        }
        setIsInboundExtended(true);
    };

    const [shipmentId, setShipmentId] = useState();
    const shipmentIdRef = useRef(shipmentId);
    
    const getShipmentDetails = (params) => {
        if (!params) return;
    
        const newShipmentId = parseInt(params.row.shipmentId);
        // Only update state if the pickingJobListId has actually changed
        if (shipmentIdRef.current !== newShipmentId) {
            if(!spShipmentLoading) {
                setSpShipmentLoading(true);
            }
            setShipmentId(newShipmentId);
            shipmentIdRef.current = newShipmentId; // Update the ref to the new value
        }
        setIsShipmentExtended(true);
    };

    const columns = [
        {field: "relationName", headerName: t("relation"),flex:2, 
            filter: INVOICE_FILTER_KEYS.RELATION,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            const handleClick = (event) => {
                event.stopPropagation(); // Prevent click from propagating to the row
                getRelationDetails(params);
            };
            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.relationName}</Text>
                </Box>
            );
        }},
        {
            field: "invoice",
            headerName: t("invoice"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                const handleClick = (event) => {
                    event.stopPropagation(); // Prevent click from propagating to the row
                    getInvoice(params);
                };
                return (
                    <Box sx={{
                                width:1,
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                ".copyel": {
                                opacity:0,
                            },
                            "&:hover .copyel": {
                                opacity:1,
                            }
                        }} onClick={handleClick}>
                        <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{`${params.row.invoiceNumber}${params.row.invoiceExternalReference?.length > 0 ? ` (${params.row.invoiceExternalReference})` : ""}`}</Text>
                    </Box>
                );
            }
        },
        {
            field: "description",
            headerName: t("description"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                const handleClick = (event) => {
                    event.stopPropagation(); // Prevent click from propagating to the row
                    getInvoiceProductDetails(params);
                };

                return (
                    <Box sx={{
                                width:1,
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                ".copyel": {
                                opacity:0,
                            },
                            "&:hover .copyel": {
                                opacity:1,
                            }
                        }} onClick={handleClick}>
                        <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.description}</Text>
                    </Box>
                );
            }
        },
        {
            field: "linkedId",
            headerName: t("linked_to"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                const handleClick = (event) => {
                    event.stopPropagation(); // Prevent click from propagating to the row

                    if (params.row.orderId > 0) {
                        getOrderDetails(params);
                    }
                    if (params.row.returnId > 0) {
                        getReturnDetails(params);
                    }
                    if (params.row.inboundId > 0) {
                        getInboundDetails(params);
                    }
                    if (params.row.shipmentId > 0) {
                        getShipmentDetails(params);
                    }
                };

                let linkedTo = "";
                if (params.row.orderId > 0) {
                    linkedTo = `${t("order")} ${params.row.orderBarcode}`;
                }
                if (params.row.returnId > 0) {
                    linkedTo = `${t("return")} ${params.row.returnReference}`;
                }
                if (params.row.inboundId > 0) {
                    linkedTo = `${t("inbound")} ${params.row.inboundBarcode}`;
                }
                if (params.row.shipmentId > 0) {
                    linkedTo = `${t("shipment")} ${params.row.shipmentTrackingNumber}`;
                }

                return (
                    <Box sx={{
                                width:1,
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                ".copyel": {
                                opacity:0,
                            },
                            "&:hover .copyel": {
                                opacity:1,
                            }
                        }} onClick={handleClick}>
                        <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{linkedTo}</Text>
                    </Box>
                );
            }
        },
        {
            field: "amount",
            headerName: t("amount"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return parseFloat(params.row.amount);
            }
        },
        {
            field: "price",
            headerName: t("price"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return formatPrice(i18n, parseFloat(params.row.price));
            }
        },
        {
            field: "total",
            headerName: t("total"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return formatPrice(i18n, (parseFloat(params.row.price) * parseFloat(params.row.amount)));
            }
        },
        {
            field: "userName",
            headerName: t("user"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.userName;
            }
        },
        {
            field: "updatedAt", 
            headerName: t("updated_at"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Text>
                        {new Date(params.row.updatedAt).toLocaleString(i18n.language)}
                    </Text>
                );
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            filter: INVOICEMUTATIONS_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const stateData = getInvoiceMutationStateData(params.row.state, theme);
                let labelcolor = stateData.labelcolor;
                let labeltext = stateData.labeltext;
                
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        // {
        //     field: "phoneView", 
        //     headerName: "PhoneView",
        //     cellClassName: "phone-column--cell",
        //     renderCell: (params) => {
        //         // WarehouseInvoiceCard
        //         return (
        //             <WarehouseInvoiceCard
        //                 onClick={() => getInvoice(params)}
        //                 skeleton={params.row.skeleton}
        //                 {...params.row}
        //             />
        //             // <ShTextSkeleton/>
        //         )
        //     }
        // },
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetInvoiceMutationsQuery}
                config={config}
                gridActions={<GridActions handleExportClick={() => exportMutationsModal.setOpen(true)}></GridActions>}
                title={t('all')}
                gridOptions={gridOptions}
                sortModel={{field: columns[7].field,type:"DESC"}}
                columns={columns}
                rows={data}
            >
            </ShDataGrid2>

            <MDynamicValues
                open={exportMutationsModal.open}
                handleClose={() => exportMutationsModal.setOpen(false)}
                title={t("export_invoice_mutations")}
                subtitle={t("max_range_invoice_startdate_28")}
                labelWidth={80}
                fields={[
                    { name: "relation", label: t("relation"), type: "list", options: relationData, search: true },
                    { name: "startdate", label: t("invoice_startdate_from"), type: "date", required: true },
                    { name: "enddate", label: t("invoice_startdate_to"), type: "date", required: true }
                ]}
                onConfirm={(values) => exportToExcel(values)}
            />

            {spRelationLoading &&
                <SpRelationDetails
                    relationId={relationId}
                    isExtended={isRelationExtended}
                    setIsExtended={setIsRelationExtended}
                    // data={pickingJobData}
                />
            }

            {spLoading &&
                <SpInvoiceDetails
                    invoiceId={invoiceId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                />
            }

            {spInvoiceProductLoading &&
                <SpInvoiceProductDetails
                    invoiceProductId={invoiceProductId}
                    isExtended={isInvoiceProductExtended}
                    setIsExtended={setIsInvoiceProductExtended}
                    // data={pickingJobData}
                />
            }

            {spOrderLoading &&
                <SpOrderDetails
                    orderId={orderId}
                    isExtended={isOrderExtended}
                    setIsExtended={setIsOrderExtended}
                    // data={pickingJobData}
                />
            }

            {spInboundLoading &&
                <SpInboundDetails
                    inboundId={inboundId}
                    isExtended={isInboundExtended}
                    setIsExtended={setIsInboundExtended}
                    // data={pickingJobData}
                />
            }

            {spReturnLoading &&
                <SpReturnDetails
                    returnId={returnId}
                    isExtended={isReturnExtended}
                    setIsExtended={setIsReturnExtended}
                    // data={pickingJobData}
                />
            }

            {spShipmentLoading &&
                <SpShipmentDetails
                    shipmentId={shipmentId}
                    isExtended={isShipmentExtended}
                    setIsExtended={setIsShipmentExtended}
                    // data={pickingJobData}
                />
            }

            <MLoader
                open={loaderModal.open}
                message={t("preparing_export")}></MLoader>
        </Box>
    );
}

export default All;